import { getDeliverySpots } from 'src/utils/firebase/firebase-short-cut';
import useSWR from 'swr';

const useDeliverySpots = () => {
  const { data: deliverySpots } = useSWR('deliverySpots', () => getDeliverySpots());

  return {
    deliverySpots,
  };
};

export default useDeliverySpots;
